import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren, ChangeDetectionStrategy } from '@angular/core';
import { gsap } from 'gsap';
@Component({
    selector: 'app-home-sliders',
    templateUrl: './home-sliders.component.html',
    styleUrls: ['./home-sliders.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeSlidersComponent implements OnInit {

  constructor(private el: ElementRef) { }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    this.waitingAnimations()

    this.updateLogoOpacity();
    // Listen to changes in the QueryList
    this.companyLogoEl.changes.subscribe(() => {
      // Call your logic when the QueryList changes
      this.updateLogoOpacity();
    });
  }
  @ViewChildren('companyLogo') companyLogoEl!: QueryList<ElementRef>;
  opacity = 1;

  
  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event): void {
    
    this.updateLogoOpacity()
  }

  private updateLogoOpacity(): void {
    if(this.companyLogoEl){
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;
      this.opacity = Math.min(scrollPosition / 100, 0);

      this.companyLogoEl.forEach((element: any) => {
        if (scrollPosition > 200) {
          element.nativeElement.style.opacity = `${this.opacity - 1}`
        } else {
          element.nativeElement.style.opacity = '1';
        }
      });
      
    }
  }

  waitingAnimations(){
    const carouselText = this.el.nativeElement.querySelectorAll('.carousel-text');

    // Hide all carousel text initially
    gsap.set(carouselText, { opacity: 1 });

    // Listen for Bootstrap Carousel slide event
    const carousel = this.el.nativeElement.querySelector('.carousel');

    if(carousel){

      carousel.addEventListener('slide.bs.carousel', (event: any) => {
        const activeIndex = event.to;
        const activeText = carouselText[activeIndex];
  
        // Animate the active text element
        gsap.fromTo(activeText, { opacity: 0, x: -100 }, { duration: 3, opacity: 1, x: 10, ease: 'power2.out', stagger: 0.2 });
      });
    }
    
  }

  
}
